import Input from "../../../form/input"

const ExternalLinks = () => (
  <>
    <div className="pt-8">
      <Input
        label="Privacy policy URL"
        name="privacy_policy_url"
        placeholder="https://example.com/privacy"
        type="url"
      />
    </div>
    <div className="pt-8">
      <Input
        label="Terms of service URL"
        name="terms_and_conditions_url"
        placeholder="https://example.com/terms"
        type="url"
      />
    </div>
  </>
)

export default ExternalLinks
